import { useTranslation } from "react-i18next";

const Photo = () => {
    const { t } = useTranslation();

    return <>{t('Require the player to submit an image.')}</>
};

export default Photo;
